import { Link } from 'react-router-dom';
import { addressCity } from 'helpers/clubLocation';
import '../../Catalog.css';
import './ClubCard.css';
import { useLanguage } from 'hooks/useLanguage';

/**
 * Картка клубу — ADR-0015, ADR-0016.
 *
 * Місто береться з головної локації, а не з дужок у назві. Дужки лишилися
 * запасним варіантом для старих назв — див. helpers/clubLocation. Філії
 * згадуються числом: перелічувати їх на картці ні до чого, повні адреси є на
 * сторінці клубу.
 */
export default function ClubCard({ club }) {
  const language = useLanguage();

  const rawName = (club.name || '').trim();
  const title = rawName.includes('(') ? rawName.split('(')[0].trim() : rawName;

  const locations = club.locations || [];
  const main = locations.find((location) => location.type === 'main') || locations[0] || null;
  const branches = Math.max(locations.length - 1, 0);

  const city =
    main?.city ||
    addressCity(main?.address || club.address) ||
    (rawName.includes('(') ? rawName.split('(')[1].split(')')[0].trim() : null);

  return (
    <Link className='catalog-card club-card press' to={`/catalogs/clubs/${club.id}`}>
      <div className='img-wrapper'>
        {club.logo ? (
          <img className='club-card-img' src={club.logo} alt='' loading='lazy' />
        ) : (
          <span className='club-logo-placeholder' aria-hidden='true' />
        )}
      </div>

      <div className='card-body'>
        <h2 className='card-name'>{title}</h2>
        {city && (
          <span className='card-meta'>
            {city}
            {branches > 0 &&
              (language === 'en'
                ? ` + ${branches} ${branches === 1 ? 'branch' : 'branches'}`
                : ` + ${branches} ${branches === 1 ? 'філія' : 'філії'}`)}
          </span>
        )}

        <div className='card-stats'>
          <span className='card-stat'>
            <span className='card-stat-value tnum'>{club.coachesCount ?? '-'}</span>
            <span className='card-stat-label'>{language === 'en' ? 'coaches' : 'тренерів'}</span>
          </span>
          <span className='card-stat'>
            <span className='card-stat-value tnum'>{club.dancersCount ?? '-'}</span>
            <span className='card-stat-label'>{language === 'en' ? 'dancers' : 'танцюристів'}</span>
          </span>
        </div>
      </div>
    </Link>
  );
}
